import { Model, createId } from "#/shared/models/model";
import { Column } from "./column";

function createDefaultColumns() {
  return [new Column()];
}

const uiDefaults = {
  padding: {},
  margin: {},
  rowgap: 0,
  columngap: 0,
  background: false,
};

export class Row extends Model {
  constructor(attributes) {
    const columns = attributes.columns?.map((column) => new Column(column)) ?? createDefaultColumns();
    const ui = { ...uiDefaults, ...attributes.ui };
    super({ ...attributes, columns, ui });
  }

  get defaults() {
    return {
      id: createId(),
      columns: createDefaultColumns(),
      rowgap: 0,
      columngap: 0,
      fullBleed: false,
      padding: undefined,
      margin: undefined,
      color: undefined,
      image: undefined,
      imagesize: undefined,
      imageposition: undefined,

      ui: uiDefaults,
    };
  }
}
